import { render, staticRenderFns } from "./xltpRelationSet.vue?vue&type=template&id=5adad51d&scoped=true&"
import script from "./xltpRelationSet.vue?vue&type=script&lang=js&"
export * from "./xltpRelationSet.vue?vue&type=script&lang=js&"
import style0 from "./xltpRelationSet.vue?vue&type=style&index=0&id=5adad51d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adad51d",
  null
  
)

export default component.exports